export default "Another male person is observed alone further down the shore of the beach and he is also wearing scuba diving gear.";